"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkSummaryViewFilters = exports.WorkSummaryView = void 0;
const WorkSummaryView_yaml_component_1 = __importDefault(require("./WorkSummaryView.yaml?component"));
exports.WorkSummaryView = WorkSummaryView_yaml_component_1.default;
const WorkSummaryViewFilters_yaml_component_1 = __importDefault(require("./WorkSummaryViewFilters.yaml?component"));
exports.WorkSummaryViewFilters = WorkSummaryViewFilters_yaml_component_1.default;
